import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllUsersListComponent } from './All-Users/all-users-list/all-users-list.component';
import { StudentPlacementReportsComponent } from './All-Users/student-placement-reports/student-placement-reports.component';
import { UserEditComponent } from './All-Users/user-edit/user-edit.component';
import { UserViewComponent } from './All-Users/user-view/user-view.component';
import { UsersAddComponent } from './All-Users/users-add/users-add.component';
import { StudentPipelinesListComponent } from './student-pipelines/student-pipelines-list/student-pipelines-list.component';
import { StudentPipelineAddComponent } from './student-pipelines/student-pipeline-add/student-pipeline-add.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import {  ClientPipelinesListComponent } from './client-pipelines/client-pipelines-list/client-pipelines-list.component';
import {  ClientPipelineAddComponent } from './client-pipelines/client-pipeline-add/client-pipeline-add.component';
import { ClientPipelinesMatchingResultsComponent } from './client-pipelines/client-pipelines-matching-results/client-pipelines-matching-results.component';
import { StudentPipelinesMatchingResultsComponent } from './student-pipelines/student-pipelines-matching-results/student-pipelines-matching-results.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'allUsers-list',
        component: AllUsersListComponent,
        
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] } 
      },
      {
        path: 'students-list',
        component: AllUsersListComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] } 
      },
      {
        path: 'students-pipeline',
        component: StudentPipelinesListComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] } 
      },
      {
        path: 'student-pipeline-add',
        component: StudentPipelineAddComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'], title: 'Student Pipeline Add' } 
      },
      {
        path: 'student-pipeline-edit/:id',
        component: StudentPipelineAddComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'], title: 'Student Pipeline Edit' } 
      },
      {
        path: 'student-pipelines/matching-results',
        component: StudentPipelinesMatchingResultsComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment'], title: 'Student Pipeline Matching Results' }
      },
      {
        path: 'client-pipelines',
        component: ClientPipelinesListComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] } 
      },
      {
        path: 'client-pipeline-add',
        component: ClientPipelineAddComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'], title: 'Client Pipeline Add' } 
      },
      {
        path: 'client-pipeline-edit/:id',
        component: ClientPipelineAddComponent,
          canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'], title: 'Client Pipeline Edit' } 
      },
      {
        path: 'client-pipelines/matching-results',
        component: ClientPipelinesMatchingResultsComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment'], title: 'Client Pipeline Matching Results' }
      },
      {
        path: 'users-add',
        component: UsersAddComponent,
        data: {
          title: 'Users Add Page'
        }
      },
      {
        path: 'student-add',
        component: UsersAddComponent,
        data: {
          title: 'Student Add Page'
        }
      },
      {
        path: 'user-view/:id',
        component: UserViewComponent,
        data: {
          title: 'User View'
        }
      },
      {
        path: 'users-edit/:id',
        component: UserEditComponent,
        data: {
          title: 'User Edit'
        }
      },
      {
        path: 'student-edit/:id',
        component: UserEditComponent,
        data: {
          title: 'Student Edit'
        }
      },
      {
        path: 'placement-reports',
        component: StudentPlacementReportsComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','HR','Training Moderator','Teacher'] } 
      },
  {
    path:'batches',
    loadChildren: () => import('./batches/batches.module').then(m => m.BatchesModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Training Moderator'] } 
  },
  {
    path:'attendance',
    loadChildren: () => import('./attendence/attendence.module').then(m => m.AttendenceModule)
  },
  {
    path:'enrollments',
    loadChildren: () => import('./enrolment/enrolment.module').then(m => m.EnrolmentModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Training Moderator','Teacher'] } 
  },
  {
    path:'discounts',
    loadChildren: () => import('./discount/discount.module').then(m => m.DiscountModule)
  },
  {
    path: 'tags',
    loadChildren: () => import('./tags/tags.module').then(m => m.TagsModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment'] } 
  },
  {
    path: 'course',
    loadChildren: () => import('./course/course.module').then(m => m.CourseModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Training Moderator','Teacher'] } 
  },
  {
    path: 'project',
    loadChildren: () => import('./project/project.module').then(m => m.ProjectModule)
  },
  {
    path: 'categories',
    loadChildren: () => import('./categories/categories.module').then(m => m.CategoriesModule)
  },
  {
    path:'business',
    loadChildren: () => import('./business/business.module').then(m => m.BusinessModule)
  },
  {
    path:'contact',
    loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Operation','HR'] } 
  },
  {
    path:'guest',
    loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)
  },   
  {
    path: 'lms',
    loadChildren: () => import('./lms/lms.module').then(m => m.LmsModule)
  },
 
  {
    path:'transaction',
    loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
  },

  {
    path:'notifications',
    loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path:'task',
    loadChildren: () => import('./task/task.module').then(m => m.TaskModule)
  },
  {
    path:'leads',
    loadChildren:() => import('./leads-new/leads-new.module').then(m => m.LeadsNewModule)
  },
  {
    path:'outsource-leads',
    loadChildren:() => import('./leads-new/leads-new.module').then(m => m.LeadsNewModule)
  },
  {
    path:'channel',
    loadChildren:() => import('./channel/channel.module').then(m => m.ChannelModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Operation'] } 
  },
  {
    path:'employees',
    loadChildren: () => import('./employee-crud/employee-crud.module').then(m => m.EmployeeCrudModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','HR'] } 
  },
  {
    path:'resources',
    loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule)
  },
  {
    path:'jobs',
    loadChildren: () => import('./jobs/jobs.module').then(m => m.JobsModule)
  },
  {
    path:'projects-tracker',
    loadChildren: () => import('./jobs/jobs.module').then(m => m.JobsModule)
  },
  {
    path:'tickets',
    loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsModule)
  },
  {
    path:'',
    loadChildren: () => import('./lms-layout/lms-layout.module').then(m => m.LmsLayoutModule)
  },
  {
    path: '',
    loadChildren: () => import('./lms-layout-new/lms-layout-new.module').then(m => m.LmsLayoutNewModule)
  },
  {
    path:'candidates-management',
    loadChildren: () => import('./candidates-management/candidates-management.module').then(m => m.CandidatesManagementModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','HR','Training Moderator'] } 
  },
  {
    path:'checklist',
    loadChildren: () => import('./checklist/checklist.module').then(m => m.ChecklistModule)
  },
  {
    path:'assets',
    loadChildren: () => import('./assets/assets.module').then(m => m.AssetsModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Sales','HR'] } 
  },
  {
    path:'nav-links',
    loadChildren : () => import('./nav-routes/nav-routes.module').then(m => m.NavRoutesModule)
  },
  {
    path:'control-management',
    loadChildren: () => import('./control-management/control-management.module').then(m => m.ControlManagementModule)
  },
  {
    path:'discussions',
    loadChildren: () => import('./discussion/discussion.module').then(m => m.DiscussionModule)
  },
  {
    path:'classes',
    loadChildren: () => import('./classes/classes.module').then(m => m.ClassesModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Training Moderator','Teacher'] } 
  },
  {
    path:'leaves',
    loadChildren: () => import('./leaves/leaves.module').then(m => m.LeavesModule)
  },  
  {
    path:'tracker',
    loadChildren: () => import('./tracker/tracker.module').then(m => m.TrackerModule)
  },
  {
    path: 'openings',
    loadChildren : () => import('./opening/opening.module').then(m=> m.OpeningModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','HR','Training Moderator'] } 
  },
  {
    path: 'credentials',
    loadChildren : () => import('./credential-management/credential-management.module').then(m=> m.CredentialManagementModule)
  },
  {
    path: '',
    loadChildren : () => import('./admin-settings/admin-settings.module').then(m=> m.AdminSettingsModule)
  },
  {
    path: 'my-attendence',
    loadChildren : () => import('./employee-crud/emp-attendence/emp-attendence.module').then(m=> m.EmpAttendenceModule)
  },
  {
    path: 'employees-attendence',
    loadChildren : () => import('./employee-crud/emp-attendence/emp-attendence.module').then(m=> m.EmpAttendenceModule)
  },
  {
    path:'events' ,
    loadChildren :() => import('./events/events.module').then(m=>m.EventsModule),
    
  },
  {
    path:'clients',
    loadChildren: () => import('./business/business.module').then(m => m.BusinessModule)
  },
  {
    path:'campaign',
    loadChildren: () => import('./campaign/campaign.module').then(m => m.CampaignModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','Sales'] } 
  },
  {
    path:'referral',
    loadChildren: () => import('./referal/referal.module').then(m => m.ReferalModule)
  },
  {
    path:'onboarding-reports',
    loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule)
  },
  {
    path:'guidelines',
    loadChildren: () => import('./guidelines/guidelines.module').then(m => m.GuidelinesModule),
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','HR','Training Moderator','Sales','Teacher','Operation'] }
  },
  {
    path:'graphy',
    loadChildren: () => import('./graphy/graphy-admin.module').then(m => m.GraphyAdminModule)
  }
]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
